/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { TeamsInRegion } from "@microsoft/shifts-models-data";
// TODO: Replace 'sh-services' dependency from Web core with one from a workspace package.
import { InstrumentationService } from "sh-services";
import { AppDb } from "sh-services/data/AppDb";

import { ICrossLocationTeamDatabase } from "./ICrossLocationTeamDatabase";

// TODO: After fixing circular dependency, move 'CrossLocationTeamDatabase' to managers package under 'crossLocationTeam' folder.
/**
 * The cross-location team database.
 */
export class CrossLocationTeamDatabase implements ICrossLocationTeamDatabase {
    /**
     * Instantiates a new instance of the CrossLocationTeamDatabase.
     * @param database The database.
     */
    constructor(private readonly database: AppDb) {}

    /**
     * Gets the cross-location teams for the current user.
     * @param teamId The team id.
     * @returns The cross-location teams for the current user.
     */
    public async getCrossLocationTeams(teamId: string): Promise<TeamsInRegion | undefined> {
        let teams: TeamsInRegion | undefined = undefined;

        try {
            const records = await this.database.crossLocationTeams.where({ teamId }).toArray();

            if (records.length > 0) {
                teams = records.map(({ team }) => team);
            }
        } catch (error) {
            InstrumentationService.trackException(error, "CrossLocationTeamDatabase.getCrossLocationTeams");
        }

        return teams;
    }

    /**
     * Sets the cross-location teams for the current user.
     * @param teamId The team id.
     * @param teams The cross-location teams.
     */
    public async setCrossLocationTeams(teamId: string, teams: TeamsInRegion): Promise<void> {
        try {
            const records = teams.map(team => ({ team, teamId }));

            await this.database.crossLocationTeams.where({ teamId }).delete();
            await this.database.crossLocationTeams.bulkPut(records);
        } catch (error) {
            InstrumentationService.trackException(error, "CrossLocationTeamDatabase.setCrossLocationTeams");
        }
    }
}
